import React from 'react';
import { QuizQuestion as QuizQuestionType } from './types';
import './QuizQuestion.css';

interface QuizQuestionProps {
  question: QuizQuestionType;
  selectedAnswer: number | null;
  showResult: boolean;
  isCorrect: boolean | null;
  timeUp: boolean;
  onAnswerSelect: (answerIndex: number) => void;
}

const QuizQuestion: React.FC<QuizQuestionProps> = ({
  question,
  selectedAnswer,
  showResult,
  isCorrect,
  timeUp,
  onAnswerSelect
}) => {
  const getButtonClass = (index: number) => {
    let baseClass = 'option-button';
    
    if (showResult) {
      if (index === question.correctAnswerIndex) {
        return `${baseClass} correct`;
      } else if (index === selectedAnswer && !isCorrect) {
        return `${baseClass} incorrect`;
      } else {
        return `${baseClass} disabled`;
      }
    } else if (selectedAnswer === index) {
      return `${baseClass} selected`;
    }
    
    return baseClass;
  };

  return (
    <div className="question-container">
      <h2 className="question-title">Kaj je {question.term}?</h2>
      <div className="options-container">
        {question.options.map((option, index) => (
          <button
            key={index}
            className={getButtonClass(index)}
            onClick={() => onAnswerSelect(index)}
            disabled={showResult}
          >
            {option}
          </button>
        ))}
      </div>     
    </div>
  );
};

export default QuizQuestion;

